import clsx from "clsx";

const radioClasses =
  "inline-flex box-border appearance-none rounded-full border border-solid border-bdc-base md:border-bdc-light bg-gray-50 p-3 md:p-3 text-sec placeholder-txt-light focus:border-sec focus:bg-white focus:outline-none focus:ring-sec sm:text-base text-base";
const checkClasses =
  "inline-flex box-border appearance-none rounded-md border border-solid border-bdc-base md:border-bdc-light bg-gray-50 p-3 md:p-3 text-sec placeholder-txt-light focus:border-sec focus:bg-white focus:outline-none focus:ring-sec sm:text-base text-base";
const inputClasses =
  "block w-full box-border appearance-none rounded-sm border border-solid border-bdc-base md:border-bdc-light bg-gray-50 px-4 py-2 md:px-6 md:py-4 text-txt-base placeholder-txt-light focus:border-sec focus:bg-white focus:outline-none focus:ring-sec sm:text-base text-base";
const textareaClasses =
  "block w-full box-border appearance-none rounded-sm border border-solid h-60 md:h-80 lg:h-100 border-bdc-base md:border-bdc-light bg-gray-50 px-4 py-2 md:px-6 md:py-4 text-txt-base placeholder-txt-light focus:border-sec focus:bg-white focus:outline-none focus:ring-sec sm:text-base text-base";

function Label({ id, children }) {
  return (
    <label htmlFor={id} className="block text-base text-txt-base">
      {children}
    </label>
  );
}
function LabelCheck({ id, children }) {
  return (
    <label htmlFor={id} className="text-base leading-snug text-txt-base">
      {children}
    </label>
  );
}
function LabelRadio({ id, children }) {
  return (
    <label htmlFor={id} className="text-base leading-snug text-txt-base">
      {children}
    </label>
  );
}

export function TextField({
  id,
  label,
  caption,
  type = "text",
  className = "",
  placeHolder = "",
  error = "",
  ...props
}) {
  return (
    <div className={className}>
      {label && <Label id={id}>{label}</Label>}
      {caption && <p className="text-sm text-txt-light">{caption}</p>}
      <input
        id={id}
        type={type}
        placeholder={placeHolder}
        className={`${inputClasses} ${error ? 'border-red-500 bg-red-50' : ''}`}
        {...props}
      />
      {error && <p className="text-sm text-red-500 mt-1">{error}</p>}
    </div>
  );
}
export function TextAreaField({
  id,
  label,
  caption,
  className = "",
  placeHolder = "",
  error = "",
  ...props
}) {
  return (
    <div className={clsx(className, "space-y-2")}>
      {label && <Label id={id}>{label}</Label>}
      {caption && <p className="text-sm text-txt-light">{caption}</p>}
      <textarea
        id={id}
        placeholder={placeHolder}
        className={`${textareaClasses} ${error ? 'border-red-500 bg-red-50' : ''}`}
        {...props}
      />
      {error && <p className="text-sm text-red-500 mt-1">{error}</p>}
    </div>
  );
}

export function SelectField({ id, label, caption, className = "", error = "", ...props }) {
  return (
    <div className={clsx(className, "space-y-2")}>
      {label && <Label id={id}>{label}</Label>}
      {caption && <p className="text-sm text-txt-light">{caption}</p>}
      <select id={id} {...props} className={clsx(inputClasses, "pr-8", error ? 'border-red-500 bg-red-50' : '')} />
      {error && <p className="text-sm text-red-500 mt-1">{error}</p>}
    </div>
  );
}

export function CheckField({ id, label, className = "", ...props }) {
  return (
    <div className={clsx(className, "flex")}>
      <input
        type="checkbox"
        id={id}
        {...props}
        className={clsx(checkClasses)}
      />
      {label && <LabelCheck id={id}>{label}</LabelCheck>}
    </div>
  );
}
export function RadioField({ id, label, className = "", ...props }) {
  return (
    <div className={clsx(className, "flex")}>
      <input type="radio" id={id} {...props} className={clsx(radioClasses)} />
      {label && <LabelRadio id={id}>{label}</LabelRadio>}
    </div>
  );
}

/**

check
<input id="checkbox[1]" class="c-checkbox" name="checkbox[1]" type="checkbox">
<label for="checkbox[1]">選択肢__1</label>

radio
<input id="radio[1][yes]" class="c-radio" name="radio[1]" type="radio">
<label for="radio[1][yes]">はい</label>

*/
